import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxC0SearchInputMessagesScheme = z.object({
  search_input_placeholder: themeScheme.MessageScheme.default(
    "Szukaj produktu, np. Kocioł 50 kW"
  ),
  search_input_placeholder_short: themeScheme.MessageScheme.default("Szukaj"),
  search_input_popup_no_permission_message: themeScheme.MessageScheme.default(
    "Brak dostępu do kamery. Proszę udzielić zgody w ustawieniach przeglądarki."
  ),
  search_dropdown_in: themeScheme.MessageScheme.default("w"),
  search_dropdown_all_categories: themeScheme.MessageScheme.default(
    "Wszystkie kategorie"
  ),
});

export const IBoxC0SearchInputSettingsScheme = z.object({
  search_input_style: themeScheme.InputIdScheme.default("input$$1"),
  search_input_close_popup_button:
    themeScheme.ButtonIdScheme.default("button$$1"),
  search_input_popup_no_permission_typo:
    themeScheme.TypoIdScheme.default("typo$$1"),
  search_input_popup_no_permission_typo_color:
    themeScheme.ColorIdScheme.default("color$$1"),
  search_input_srp_link: themeScheme.MessageScheme.default(""),
});
